// Engagement charts — daily signups, recordings, practice, and new
// conversation-progress rows. All four series come from the same
// /api/admin/engagement payload.

import React, { useEffect, useState } from 'react';
import { getEngagement } from '../adminApi';
import { Loading, Err } from './Overview';
import MiniLineChart from '../components/MiniLineChart';

const RANGES = [7, 30, 90];

export default function Engagement() {
    const [data, setData] = useState(null);
    const [err, setErr] = useState(null);
    const [days, setDays] = useState(30);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            setData(null);
            try {
                const d = await getEngagement({ days });
                if (!cancelled) setData(d);
            } catch (e) {
                if (!cancelled) setErr(e?.message || 'Failed to load');
            }
        })();
        return () => { cancelled = true; };
    }, [days]);

    if (err) return <Err msg={err} />;

    return (
        <div>
            <h2 style={styles.h2}>Engagement</h2>
            <div style={styles.tabs}>
                {RANGES.map((d) => (
                    <button
                        key={d}
                        onClick={() => setDays(d)}
                        style={{ ...styles.tab, ...(days === d ? styles.tabActive : null) }}
                    >
                        Last {d} days
                    </button>
                ))}
            </div>

            {!data ? <Loading /> : (
                <div style={styles.grid}>
                    <ChartCard title="New signups" series={data.signups} color="#d97447" />
                    <ChartCard title="Recordings (Capeesh)" series={data.recordings} color="#27BE78" />
                    <ChartCard title="Practice reviews" series={data.practice} color="#276EBE" />
                    <ChartCard title="Conversation progress events" series={data.progress} color="#7a4ed8" />
                </div>
            )}
        </div>
    );
}

function ChartCard({ title, series, color }) {
    const total = (series || []).reduce((sum, d) => sum + (d.count || 0), 0);
    return (
        <div style={styles.card}>
            <div style={styles.cardHeader}>
                <span style={styles.cardTitle}>{title}</span>
                <span style={styles.cardTotal}>{total.toLocaleString()}</span>
            </div>
            <MiniLineChart data={series} color={color} />
        </div>
    );
}

const styles = {
    h2: { marginTop: 0, color: '#222' },
    tabs: { display: 'flex', gap: 6, marginBottom: 12 },
    tab: { padding: '6px 14px', borderRadius: 16, border: '1px solid #ddd', background: '#fff', color: '#555', cursor: 'pointer', fontSize: 13 },
    tabActive: { background: '#d97447', borderColor: '#d97447', color: '#fff', fontWeight: 600 },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(420px, 1fr))', gap: 12 },
    card: { backgroundColor: '#fff', borderRadius: 12, padding: 16 },
    cardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 8 },
    cardTitle: { fontSize: 13, color: '#d97447', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 },
    cardTotal: { fontSize: 18, fontWeight: 800, color: '#222' },
};
